import type { SVGProps } from 'react'
const SvgSyChevronUp = (props: SVGProps<SVGSVGElement>) => (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width={24} height={24} {...props}>
		<path d="m11.469 7.969-7 7a.75.75 0 0 0 0 1.062.75.75 0 0 0 1.062 0L12 9.563l6.469 6.468a.75.75 0 0 0 1.062 0 .75.75 0 0 0 0-1.062l-7-7a.75.75 0 0 0-1.062 0" />
	</svg>
)
export default SvgSyChevronUp
